import React from 'react';
import PropTypes from 'prop-types';

import { Avatar, CircularProgress, Tooltip } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';

import { styled } from '@mui/material/styles';

const AvatarClass = styled(Avatar, {
  shouldForwardProp: prop => !['isSuccessful'].includes(prop),
})(({ isSuccessful, theme }) => ({
  backgroundColor: isSuccessful ? theme.palette.success.light : theme.palette.error.light,
  color: isSuccessful ? theme.palette.success.dark : theme.palette.error.dark,
  fontSize: '16px',
  height: theme.spacing(3),
  width: theme.spacing(3),
}));

const IndividualProgressIndicator = ({ error, isSuccessful }) => {
  if (isSuccessful) {
    return (
      <AvatarClass data-testid="success" isSuccessful>
        <CheckRoundedIcon />
      </AvatarClass>
    );
  }

  if (error) {
    return (
      <Tooltip enterTouchDelay={10} placement="top" title={error.title}>
        <AvatarClass>
          <PriorityHighRoundedIcon fontSize="inherit" />
        </AvatarClass>
      </Tooltip>
    );
  }

  return <CircularProgress color="secondary" size={24} />;
};

IndividualProgressIndicator.propTypes = {
  error: PropTypes.string,
  isSuccessful: PropTypes.bool.isRequired,
};

IndividualProgressIndicator.defaultProps = {
  error: '',
};

export default IndividualProgressIndicator;
